import { PageTitle } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import boat from '../common/assets/svg/boat.svg';

export const Error: FunctionComponent = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div className="w-1/2 mt-8 ml-8 text-center">
        <PageTitle className="pt-3 pb-2 font-semibold text-primary text-5xl">
          Sorry we misdirected you
        </PageTitle>
        <h1 className="font-normal text-xl text-black mt-8">
          Let’s take a breath and see where things went askew
        </h1>
        <div className="flex justify-center mt-8 gap-12">
          <button
            className="border border-1 border-primary w-64 h-12 rounded bg-white  text-primary"
            onClick={() => navigate('/')}
          >
            Home
          </button>
          <button
            className="w-64 h-12 rounded bg-primary text-white"
            onClick={() => navigate(-1)}
          >
            We Must Go Back
          </button>
        </div>
      </div>
      <div className="relative">
        <img alt="" className="absolute bottom right-0" src={boat} />
      </div>
    </div>
  );
};
